module.exports = __webpack_public_path__ + "img/122.8c045742.jpg";